import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import Api from "../../../shared/api/api";
import "../styles/AboutPage.css";

export default function AboutPage() {
  const [about, setAbout] = useState(null);
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let isMounted = true;

    async function fetchAbout() {
      try {
        setStatus("loading");

        const response = await Api.getAllAuthor("about", {
          cache: "no-store",
        });

        if (!isMounted) return;

        const aboutEntries = Array.isArray(response)
          ? response
          : response?.about || response?.data || [];

        const aboutRecord = Array.isArray(aboutEntries)
          ? aboutEntries[0]
          : aboutEntries;

        if (!aboutRecord) {
          setStatus("empty");
          return;
        }

        setAbout(aboutRecord);
        setStatus("success");
      } catch (error) {
        if (!isMounted) return;

        console.error("Error loading About page:", error);
        setStatus("error");
      }
    }

    fetchAbout();

    return () => {
      isMounted = false;
    };
  }, []);

  if (status === "loading") {
    return (
      <main className="aboutDiv">
        <p className="loadingMsg" role="status">
          Loading author information...
        </p>
      </main>
    );
  }

  if (status === "error") {
    return (
      <main className="aboutDiv">
        <h1 className="aboutName">About the Author</h1>

        <p className="warningError" role="alert">
          Author information could not be loaded. Please try again later.
        </p>
      </main>
    );
  }

  if (status === "empty" || !about) {
    return (
      <main className="aboutDiv">
        <h1 className="aboutName">About the Author</h1>

        <p className="loadingMsg">
          Author information is not currently available.
        </p>
      </main>
    );
  }

  const authorName = about.name?.trim() || "Kenneth L. Powell";
  const biography =
    about.long_bio?.trim() ||
    about.longBio?.trim() ||
    about.biography?.trim() ||
    "";

  return (
    <main className="aboutDiv">
      <h1 className="aboutName">About the Author — {authorName}</h1>

      {about.image && (
        <img
          className="aboutImage leftAboutCol"
          src={about.image}
          alt={`Portrait of ${authorName}`}
          loading="lazy"
          decoding="async"
        />
      )}

      {biography ? (
        <div className="aboutLongBio">
          <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>
            {biography}
          </ReactMarkdown>
        </div>
      ) : (
        <p className="aboutLongBio">
          Biography information is not currently available.
        </p>
      )}
    </main>
  );
}